module.exports = __webpack_public_path__ + "static/2016-header-770447a8f9d38547b75d7a365634a971.jpg";